import React from "react";

const TabUsuarios = ({
  searchTerm,
  setSearchTerm,
  filterType,
  setFilterType,
  setSelectedFilter,
  sortField,
  sortDirection,
  handleSort,
  showTooltip,
  setShowTooltip,
  filteredUsuarios,
  recoveryStatus,
  confirmResetPassword,
  confirmDeleteUser,
  handleConfirmReactivarCuenta,
  confirmDeletePermanente,
}) => {
  return (
    <>
      {/*-------------------- Inicio componente de búsquedas y filtrado  --------------------*/}
      <div className="mb-5">
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <div className="w-full md:w-1/2">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <i className="bx bx-search text-gray-400 text-xl"></i>
              </div>
              <input
                type="text"
                className="w-full pl-12 pr-4 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 text-sm"
                placeholder="Buscar por nombre, email o empresa"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="w-full md:w-1/2">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <i className="bx bx-filter-alt text-gray-400 text-xl"></i>
              </div>
              <select
                className="appearance-none w-full pl-12 pr-10 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 text-sm cursor-pointer"
                value={filterType}
                onChange={(e) => {
                  setFilterType(e.target.value);
                  setSelectedFilter(e.target.value);
                }}
              >
                <option value="activos">Usuarios Activos</option>
                <option value="inactivos">Usuarios Inactivos</option>
                <option value="ya_registrada">Empresa registrada</option>
                <option value="no_registrada">Empresa no registrada</option>
                <option value="sin_empresa">Sin empresa</option>
                <option value="todos">Todos</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      {/*-------------------- Fin componente de búsquedas y filtrado  --------------------*/}
      <div className="flex justify-center w-full">
        <div className="w-full overflow-hidden rounded-lg shadow">
          <table className="w-full text-sm text-left text-gray-700">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 border-b">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort("id_usuario")}
                >
                  <div className="flex items-center justify-between">
                    <span>Id</span>
                    <span className="ml-2 text-gray-500">
                      {sortField === "id_usuario" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort("nombreCompleto")}
                >
                  <div className="flex items-center justify-between">
                    <span>Nombre</span>
                    <span className="ml-2 text-gray-500">
                      {sortField === "nombreCompleto" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort("email")}
                >
                  <div className="flex items-center justify-between">
                    <span>Email</span>
                    <span className="ml-2 text-gray-500">
                      {sortField === "email" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100 relative"
                  onClick={() => handleSort("validaEmpresa")}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <span>Estatus Empresa</span>
                      <div className="relative ml-1">
                        <i
                          className="bx bx-info-circle text-blue-600 cursor-help"
                          onMouseEnter={() => setShowTooltip(true)}
                          onMouseLeave={() => setShowTooltip(false)}
                        ></i>
                        {showTooltip && (
                          <div className="absolute z-50 top-full left-0 mt-1 w-64 bg-white rounded-md shadow-lg border border-gray-200 p-3 text-sm">
                            <div className="font-semibold text-gray-800 mb-2 pb-1 border-b">
                              ESTADOS DE LA EMPRESA:
                            </div>
                            <div className="space-y-3">
                              <div className="flex items-start">
                                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 border border-green-600 mt-0.5"></div>
                                <div className="ml-2">
                                  <div className="font-semibold text-green-700">
                                    YA REGISTRADA:
                                  </div>
                                  <div className="text-gray-600 text-xs">
                                    LA EMPRESA EXISTE EN EL SISTEMA
                                  </div>
                                </div>
                              </div>
                              <div className="flex items-start">
                                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-orange-200 border border-orange-600 mt-0.5"></div>
                                <div className="ml-2">
                                  <div className="font-semibold text-orange-700">
                                    NO REGISTRADA:
                                  </div>
                                  <div className="text-gray-600 text-xs">
                                    LA EMPRESA NO EXISTE EN EL SISTEMA
                                  </div>
                                </div>
                              </div>
                              <div className="flex items-start">
                                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-red-200 border border-red-600 mt-0.5"></div>
                                <div className="ml-2">
                                  <div className="font-semibold text-red-700">
                                    SIN EMPRESA:
                                  </div>
                                  <div className="text-gray-600 text-xs">
                                    EL USUARIO NO TIENE EMPRESA ASIGNADA
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <span className="ml-2 text-gray-500">
                      {sortField === "validaEmpresa" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort("empresa")}
                >
                  <div className="flex items-center justify-between">
                    <span>Empresa</span>
                    <span className="ml-2 text-gray-500">
                      {sortField === "empresa" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSort("fechaRegistro")}
                >
                  <div className="flex items-center justify-between">
                    <span>Fecha</span>
                    <span className="ml-2 text-gray-500">
                      {sortField === "fechaRegistro" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100 text-center"
                  onClick={() => handleSort("estatus")}
                >
                  <div className="flex items-center justify-center">
                    <span>Acciones</span>
                    <span className="ml-8 text-gray-500">
                      {sortField === "estatus" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredUsuarios.length > 0 ? (
                filteredUsuarios.map((item) => (
                  <tr
                    key={item.id_usuario}
                    className="border-b hover:bg-gray-50"
                  >
                    <td className="px-6 py-4 font-medium">{item.id_usuario}</td>
                    <td className="px-6 py-4">{item.nombreCompleto}</td>
                    <td className="px-6 py-4">{item.email}</td>
                    <td className="px-6 py-4">
                      <span
                        className={`px-2 py-1 text-xs font-medium rounded-full ${
                          item.validaEmpresa === "Ya registrada"
                            ? "bg-green-100 text-green-800"
                            : item.validaEmpresa === "Sin empresa"
                            ? "bg-red-200 text-red-600"
                            : "bg-orange-200 text-orange-600"
                        }`}
                      >
                        {item.validaEmpresa}
                      </span>
                    </td>
                    <td className="px-6 py-4">{item.empresa}</td>
                    <td className="px-6 py-4">{item.fechaRegistro}</td>
                    <td className="px-6 py-4">
                      <div className="flex justify-center gap-2">
                        {/* Botón de restablecer contraseña */}
                        <button
                          onClick={() => confirmResetPassword(item)}
                          title="Restablecer contraseña"
                          className={`inline-flex items-center justify-center rounded-lg h-9 w-9 transition-colors
                            ${
                              recoveryStatus.email === item.email &&
                              recoveryStatus.status === "success"
                                ? "bg-green-600 hover:bg-green-700"
                                : recoveryStatus.email === item.email &&
                                  recoveryStatus.status === "error"
                                ? "bg-red-600 hover:bg-red-700"
                                : "bg-blue-600 hover:bg-blue-700"
                            }`}
                        >
                          <i
                            className={`${
                              recoveryStatus.email === item.email &&
                              recoveryStatus.status === "success"
                                ? "bx bx-check"
                                : recoveryStatus.email === item.email &&
                                  recoveryStatus.status === "error"
                                ? "bx bx-x"
                                : "bx bx-lock"
                            } text-white text-xl ${
                              recoveryStatus.email === item.email
                                ? "animate-fade-in"
                                : ""
                            }`}
                          />
                        </button>

                        {item.estatus === "1" ? (
                          // Si está activo: permitir desactivarlo
                          <button
                            onClick={() =>
                              confirmDeleteUser(
                                item.id_usuario,
                                item.nombreCompleto
                              )
                            }
                            className="inline-flex items-center justify-center bg-[#F47F36] hover:bg-orange-400 text-white rounded-lg h-9 w-9"
                            title="Desactivar usuario"
                          >
                            <i className="bx bx-user-minus text-xl"></i>
                          </button>
                        ) : (
                          <>
                            {/* Si está inactivo: permitir reactivar */}
                            <button
                              onClick={() => handleConfirmReactivarCuenta(item)}
                              title="Reactivar usuario"
                              className="inline-flex items-center justify-center bg-green-600 hover:bg-green-700 text-white rounded-lg h-9 w-9"
                            >
                              <i className="bx bx-reset text-xl"></i>
                            </button>
                          </>
                        )}
                        {/* Eliminar permanentemente */}
                        <button
                          onClick={() =>
                            confirmDeletePermanente(
                              item.id_usuario,
                              item.nombreCompleto
                            )
                          }
                          className="inline-flex items-center justify-center bg-red-600 hover:bg-red-700 text-white rounded-lg h-9 w-9"
                          title="Eliminar permanentemente"
                        >
                          <i className="bx bx-trash text-xl"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="border-b">
                  <td
                    colSpan={7}
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    {searchTerm
                      ? "No se encontraron resultados para tu búsqueda"
                      : "No hay usuarios registrados"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default TabUsuarios;
